export default __webpack_public_path__ + "static/media/Tozzini.e305df7f.jpg";